import "@Styles/Pages/Recipe/rdp_sm.less";
import "@Styles/Pages/Recipe/PB/rdp_sm.less";
import "@Styles/Pages/Recipe/rdp_md.less";
import "@Styles/Pages/Recipe/PB/rdp_md.less";
import "@Styles/Pages/Recipe/rdp_lg.less";
import "@Styles/Pages/Recipe/PB/rdp_lg.less";
var recipeDrawer = function recipeDrawer() {
  return import(
  /* webpackChunkName: "recipeDrawer" */
  '@Shared/RecipeParts/Scripts/recipeDrawer');
};

var relatedContent = function relatedContent() {
  return import(
  /* webpackChunkName: "relatedContent" */
  '@Shared/RelatedContent/Scripts/relatedContent');
};

var recipeStepShots = function recipeStepShots() {
  return import(
  /* webpackChunkName: "recipeStepShots" */
  '@Shared/RecipeParts/Scripts/recipeStepShots');
};

var recipeNutrition = function recipeNutrition() {
  return import(
  /* webpackChunkName: "recipeNutrition" */
  '@Shared/RecipeParts/Scripts/recipeNutrition');
};

var wakeLockShared = function wakeLockShared() {
  return import(
  /* webpackChunkName: "wakeLockShared" */
  '@Shared/ActionToolbar/Scripts/wakeLock');
};

var thirdPartyScript = function thirdPartyScript() {
  return import(
  /* webpackChunkName: "thirdPartyScript" */
  '../../Controls/ThirdPartyScript/thirdPartyScript');
};

var brandingHeader = function brandingHeader() {
  return import(
  /* webpackChunkName: "brandingHeader" */
  '@Shared/NativeAds/Scripts/brandingHeader');
};

var recipeTipCategory = function recipeTipCategory() {
  return import(
  /* webpackChunkName: "recipeTipCategory" */
  '@Shared/RecipeParts/Scripts/_recipeTipCategory');
};

import madeWithBadge from '@Shared/RecipeParts/Scripts/madeWithBadge';
import actionToolbar from '@Shared/ActionToolbar/Scripts/actionToolbar';
import videoOverlay from '@Shared/Youtube/Scripts/videoOverlay';
import videoWatchButton from '@Shared/Youtube/Scripts/videoWatchButton';
import expandableTextContainer from '@Shared/Common/Scripts/Components/_expandableTextContainer';
import recipeIngredients from '@Shared/RecipeParts/Scripts/_recipeIngredients';
import recipeTipsCarousel from '@Shared/RecipeParts/Scripts/recipeTipsCarousel';
import recipeObserver from '@Shared/RecipeParts/Scripts/recipeObserver';
import recipeFaq from '@Shared/RecipeParts/Scripts/recipeFaq';

(function () {
  GeneralMills.PandoSites.RegisterModules({
    recipeDrawer: recipeDrawer,
    relatedContent: relatedContent,
    madeWithBadge: madeWithBadge,
    recipeStepShots: recipeStepShots,
    recipeNutrition: recipeNutrition,
    actionToolbar: actionToolbar,
    wakeLockShared: wakeLockShared,
    thirdPartyScript: thirdPartyScript,
    videoOverlay: videoOverlay,
    videoWatchButton: videoWatchButton,
    expandableTextContainer: expandableTextContainer,
    brandingHeader: brandingHeader,
    recipeIngredients: recipeIngredients,
    recipeTipCategory: recipeTipCategory,
    recipeTipsCarousel: recipeTipsCarousel,
    recipeFaq: recipeFaq
  });
  recipeObserver();
})();